import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EventTrackerService } from '../../services/event-tracker.service';
import { LocalStorageService } from '../../services/localStorage.service';
import { Subscription } from 'rxjs';
import { membership } from '../../enums/membership.enum';
import { OUTLET_ENUMS } from './choose-outlet.enum';
import { EasyEatHqService } from '../../services/ee-hq.service';
import { DuesLockService } from '../../services/dues-lock.service';
import { DuesSegment } from '../../enums/dues-lock.enum';

@Component({
  selector: 'app-choose-outlet',
  templateUrl: './choose-outlet.component.html',
  styleUrls: ['./choose-outlet.component.css'],
})
export class ChooseOutletComponent implements OnInit, OnChanges {
  membershipOutlet = {
    LITE : membership.LITE
  }
  outletList = [];
  selectedOutlet: any;
  @Input() pushAllOutlets: boolean = false;
  @Input() isMultiSelect: boolean;
  @Input() isSettlement: boolean = false;
  @Output() outletChange = new EventEmitter();
  @Input() isThirdParty: boolean = false;
  @Input() isPricingFilter: boolean = false;
  @Input() persistOutletSelection: boolean = false;
  @Input() hideKioskOutlet: boolean = false;
  /* POS-18027: when set, outlets whose dues are overdue for this segment are
     dropped from the list. Opt-in, so the other consumers are unaffected. */
  @Input() duesSegment: DuesSegment;

  translationText;
  subscription = new Subscription();
  allOutlets: any = {
    id: OUTLET_ENUMS.ALL_OUTLETS,
    name: 'All Outlets',
    settings: {},
  }

  constructor(
    private _eventTracker: EventTrackerService,
    public translateService: TranslateService,
    private _localStorage: LocalStorageService,
    private _hqService: EasyEatHqService,
    private _duesLockService: DuesLockService
  ) {
    this.translateService.use(localStorage.getItem('language') || 'en_US');
    // this.setMatSelectValues();
  }

  setOutletList() {
    const hqSettings = JSON.parse(this._localStorage.get('hq_settings') || '{}');
    const isKioskHq = hqSettings?.global?.is_kiosk_hq == 1;

    if (isKioskHq && this.hideKioskOutlet) {
      this.outletList = JSON.parse(this._localStorage.get('ee_outlets') || '[]');
    } else {
      this.outletList = JSON.parse(this._localStorage.get('staff_centre_outlets') || '[]');
    }

    if (this.duesSegment) {
      this.outletList = this.outletList.filter(
        (outlet) => !this._duesLockService.isOutletLocked(outlet, this.duesSegment)
      );
    }
  }

  ngOnInit() {
    this.setOutletList();
    this.setTranslations();
    this.setMatSelectValues();
    // this.outletChange.emit(this.selectedOutlet);
  }

  setTranslations() {
    this.subscription.add(
      this.translateService.get(['PROMOTIONS']).subscribe((res) => {
        this.translationText = res.PROMOTIONS;
        this.allOutlets = {
          id: OUTLET_ENUMS.ALL_OUTLETS,
          name: this.translationText.ALL_OUTLETS,
          settings: {},
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }


  setMatSelectValues() {
    if (this.isMultiSelect && this.isThirdParty) {
      this.selectedOutlet = [];
    } else if (this.isMultiSelect && !this.isSettlement) {
      this.selectedOutlet = [...this.outletList.map((item) => item.id)];
    } else if (this.isMultiSelect && this.isSettlement) {
      let settlementEnabledRest = [
        ...this.outletList.filter((item) => {
          if (
            item.settings &&
            item.settings.settlement &&
            item.settings.settlement.visible
          )
            return true;
          else false;
        }),
      ];
      this.selectedOutlet = [...settlementEnabledRest.map((item) => item.id)];
    } else if(this.pushAllOutlets){
      this.selectedOutlet = this._localStorage.get('hq_promotions_selected_outlet') || OUTLET_ENUMS.ALL_OUTLETS;
      if(this.outletList[0].id !== OUTLET_ENUMS.ALL_OUTLETS){
        this.outletList.unshift(this.allOutlets);
      }
    }else if (this.isPricingFilter) {
      const proRest = this.outletList.filter((outlet) =>
        this.isSettlement
          ? (((outlet || {}).settings || {}).global || {}).plan !==
            membership.LITE
          : (((outlet || {}).settings || {}).global || {}).plan ===
            membership.PRO
      );
      this.selectedOutlet = proRest[0].id;
    } else if (this.persistOutletSelection) {
      const hqPromotionsSelectedOutlet = this._localStorage.get(
        'hq_promotions_selected_outlet'
      );
      this.selectedOutlet =
        hqPromotionsSelectedOutlet &&
        hqPromotionsSelectedOutlet !== OUTLET_ENUMS.ALL_OUTLETS
          ? hqPromotionsSelectedOutlet
          : this._localStorage.get('restaurant_id');
    } else {
      this.selectedOutlet = this._localStorage.get('restaurant_id');
    }
    this.applyDuesFallbackSelection();
    this.outletChange.emit(this.selectedOutlet);
  }

  /* Single-select defaults to localStorage.restaurant_id, which at HQ login is
     the first outlet regardless of its dues state. If that outlet has been
     filtered out, the dropdown would show a value that isn't in the list. */
  applyDuesFallbackSelection() {
    if (!this.duesSegment || this.isMultiSelect) {
      return;
    }
    const isAvailable = this.outletList.some(
      (outlet) => outlet.id === this.selectedOutlet
    );
    if (!isAvailable) {
      this.selectedOutlet = (this.outletList[0] || {}).id;
    }
  }

  ngOnChanges(changes: SimpleChanges) {    
    if (changes?.pushAllOutlets && changes?.pushAllOutlets?.previousValue !== undefined) {
      this.setMatSelectValues();
    }

    if (changes?.hideKioskOutlet &&
      changes.hideKioskOutlet?.previousValue !== undefined && 
      changes.hideKioskOutlet?.currentValue !== undefined && 
      changes.hideKioskOutlet.previousValue !== changes.hideKioskOutlet.currentValue) {
      this.setOutletList();
      this.setMatSelectValues();
    }

    if (
      changes?.isMultiSelect?.currentValue !== changes?.isMultiSelect?.previousValue
    ) {
      this.setMatSelectValues();
    }
  }
  onOutletChange(e) {
    this.outletChange.emit(e);
  }
  returnRestName(id) {
    for (const [i, rest] of this.outletList.entries()) {
      if (rest.id === id) return rest.name;
    }
  }
}
